// extracted by mini-css-extract-plugin
export default {"item":"ListItem_item__ZQsyC","key":"ListItem_key__epzf7","value":"ListItem_value__8bnyJ"};